import School  from "../school.classe";
import Student  from "../student.class";
export default class Sunuvie {
    constructor() {
        this.duree = 10
        this.branche = "Responsabilité Civile Scolaire"
        this.assureur = ["FINAFRICA", "NSIA", "SANLAMALLIANZ"]
        this.dateEffet = null
        this.dateEcheance = null
        this.garanties = ['HOSPITALISATION', 'DECES ET INVALIDITE TOTALE ET DEFINITIVE']
        this.School = new School()
        this.Student = new Student()
    }
}